import styled from "styled-components";
import { color } from "../../theme/Color";

export const MixLineOverlapBarChart = styled.div`
  & .noDataFound {
    min-height: 240px;
    border: ${({ mode }) =>
      mode === "light"
        ? `1px solid ${color._D7E5F8}`
        : `1px solid rgba(255, 255, 255, 0.2)`};
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 20px;
  }
  & .customHeight {
    min-height: 172px;
  }
`;
